import { render, staticRenderFns } from "./RequestKanbanBoard.vue?vue&type=template&id=68736bce&scoped=true"
import script from "@/components/request/RequestKanbanBoard/RequestKanbanBoard.ts?vue&type=script&lang=ts&external"
export * from "@/components/request/RequestKanbanBoard/RequestKanbanBoard.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/request/RequestKanbanBoard/request-kanban-board.scss?vue&type=style&index=0&id=68736bce&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68736bce",
  null
  
)

export default component.exports